/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum FilterCollation {
    Ordinal = 'ordinal',
    Ignorecase = 'ignorecase',
    Lexicographic = 'lexicographic',
}
